/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { isEqual } from 'lodash';
import hwaxios from '../api-service/HWAxios';
import { dashboardTypes } from '../reduxExports';
import rmsStore from '../rmsStore';

const baseUrl = process.env.REACT_APP_SERVER_BASE_URL;

export const setDashboardHeaderLoader:any =
  (val: boolean) =>
    async (
      dispatch: (action: Partial<DashboardAction>) => void
    ): Promise<void> => {
      const loaderAction: Partial<DashboardAction> = {
        type: dashboardTypes.SET_DASHBOARD_STATE_DATA,
        dashboardHeaderLoader: val,
      };
      dispatch(loaderAction);
    };

export const setDashboardChargerHealthStatusLoader:any =
  (val) =>
    async (dispatch): Promise<void> => {
      const loaderAction: Partial<DashboardAction> = {
        type: dashboardTypes.SET_DASHBOARD_STATE_DATA,
        chargerHealthGraphLoader: val,
      };
      dispatch(loaderAction);
    };

export const setAlarmSummaryCountLoader:any =
  (val) =>
    async (dispatch): Promise<void> => {
      const loaderSuccessAction: Partial<DashboardAction> = {
        type: dashboardTypes.SET_DASHBOARD_STATE_DATA,
        alarmSummaryCountLoader: val,
      };
      dispatch(loaderSuccessAction);
    };


const setCustomerWiseChargerHealthGraphLoader =
  (val) =>
    async (dispatch): Promise<void> => {
      const loaderSuccessAction: Partial<DashboardAction> = {
        type: dashboardTypes.SET_DASHBOARD_STATE_DATA,
        customerWiseChargerHealthGraphLoader: val,
      };
      dispatch(loaderSuccessAction);
    };

export const fetchDashboardHeaderData:any =
  (reqBody) =>
    async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
      const url = baseUrl + '/dashboard';
      try {
        setDashboardHeaderLoader(true);

        const response = await hwaxios.post(url, reqBody);

        const action: Partial<DashboardAction> = {
          type: dashboardTypes.FETCH_DASHBOARD_HEADER_DATA,
          dashboardHeaderData: response?.data,
        };
        dispatch(action);
      } catch (error) {
        setDashboardHeaderLoader(false);
        console.error(error);

        throw error;
      }
    };

export const fetchAlarmSummaryData:any =
  (reqBody) =>
    async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
      const url = baseUrl + '/dashboard/alarm-summary';
      try {
        const response = await hwaxios.get(url);

        const action: Partial<DashboardAction> = {
          type: dashboardTypes.FETCH_ALARM_SUMMARY_DATA,
          alarmSummaryData: response?.data?.data,
          alarmSummaryDataNextToken: response?.data?.nextToken,
        };
        dispatch(action);
      } catch (error) {
        console.error(error);

        throw error;
      }
    };

export const fetchCustomerHealthData:any =
  (reqBody) =>
    async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
      const url = baseUrl + '/dashboard/charger-working-status';
      try {
        setCustomerWiseChargerHealthGraphLoader(true);
        const response = await hwaxios.post(url, reqBody);

        const action: Partial<DashboardAction> = {
          type: dashboardTypes.FETCH_CUSTOMER_HEALTH_DATA,
          customerWiseChargerHealthData: response.data,
          customerWiseChargerHealthDataNextToken: response.data?.nextToken,
        };
        dispatch(action);
        setCustomerWiseChargerHealthGraphLoader(true);
        return response.data;
      } catch (error) {
        console.error(error);
        setCustomerWiseChargerHealthGraphLoader(true);
        throw error;
      }
    };

export const fetchDashboardChargerHealthData:any =
  (reqBody) =>
    async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
      const url =
        process.env.REACT_APP_SERVER_BASE_URL +
        '/dashboard/charger-health-status';
      try {
        setDashboardChargerHealthStatusLoader(true);
        const response = await hwaxios.post(url, reqBody);

        const action: Partial<DashboardAction> = {
          type: dashboardTypes.FETCH_CHARGER_HEALTH_DATA,
          chargerHealthData: response.data?.data,
        };
        dispatch(action);
        setDashboardChargerHealthStatusLoader(false);
        return response.data;
      } catch (error) {
        setDashboardChargerHealthStatusLoader(false);
        console.log(error);
        throw error;
      }
    };

    export const fetchConnectivityMediumData:any =
  (reqBody) =>
    async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
      const url = baseUrl + '/dashboard/charger-by-connectivity';
      try {
        setCustomerWiseChargerHealthGraphLoader(true);
        const response = await hwaxios.post(url, reqBody);
        
        const action: Partial<DashboardAction> = {
          type: dashboardTypes.FETCH_CONNECTIVITY_MEDIUM_DATA,
          connectivityMediumData: response.data?.data,
        };
        dispatch(action);
        setCustomerWiseChargerHealthGraphLoader(true);
        return response.data;
      } catch (error) {
        console.error(error);
        setCustomerWiseChargerHealthGraphLoader(true);
        throw error;
      }
    };


    export const fetchNewDashboardHeaderData:any =
   (reqBody) =>
    async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
      const url = baseUrl + '/newDashboard';
      // dispatch({
      //   type: dashboardTypes.FETCH_NEW_DASHBOARD_HEADER_DATA,
      //   newDashboardHeaderData: null,
      // });

      const reqFilterHash = reqBody?.filters || {};
      const hashAction: Partial<DashboardAction> = {
        type: dashboardTypes.SET_NEW_DASHBOARD_HEADER_FILTER_HASH,
        newDashboardHeaderFilterHsah: reqFilterHash,
      }
      dispatch(hashAction);
      try {
        setDashboardHeaderLoader(true);

        const response = await hwaxios.post(url, reqBody);

        if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardHeaderFilterHsah)) {
          const action: Partial<DashboardAction> = {
            type: dashboardTypes.FETCH_NEW_DASHBOARD_HEADER_DATA,
            newDashboardHeaderData: response?.data,
          };
          dispatch(action);
        }
      } catch (error) {
        setDashboardHeaderLoader(false);
        console.error(error);

        throw error;
      }
    };

    export const fetchNewDashboardRealTimeGunInfo:any =
    (reqBody) =>
     async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
       const url = baseUrl + '/newDashboard/real-time-utilization-info';
      //  dispatch({
      //   type: dashboardTypes.FETCH_NEW_DASHBOARD_REAL_TIME_GUN_INFO,
      //   newDashboardRealTimeGunsInfo: null,
      // });

      const reqFilterHash = reqBody?.filters || {};
      const hashAction: Partial<DashboardAction> = {
        type: dashboardTypes.SET_NEW_DASHBOARD_REALTIME_GUN_INFO_FILTER_HASH,
        newDashboardRealtimeGunInfoFilterHash: reqFilterHash,
      }
      dispatch(hashAction);
       try {
         setDashboardHeaderLoader(true);
 
         const response = await hwaxios.post(url, reqBody);
 
         if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardRealtimeGunInfoFilterHash)) {
          const action: Partial<DashboardAction> = {
            type: dashboardTypes.FETCH_NEW_DASHBOARD_REAL_TIME_GUN_INFO,
            newDashboardRealTimeGunsInfo: response?.data,
          };
          dispatch(action);
         }
       } catch (error) {
         setDashboardHeaderLoader(false);
         console.error(error);
 
         throw error;
       }
    };

     export const fetchNewDashboardConnectivityMediumData:any =
     (reqBody) =>
       async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
         const url = baseUrl + '/newDashboard/charger-by-connectivity';
        //  dispatch({
        //   type: dashboardTypes.FETCH_NEW_DASHBOARD_CONNECTIVITY_MEDIUM_DATA,
        //   newDashboardConnectivityMediumData: null,
        // });

        const reqFilterHash = reqBody?.filters || {};
        const hashAction: Partial<DashboardAction> = {
          type: dashboardTypes.SET_NEW_DASHBOARD_CONNECTIVITY_MEDIUM_FILTER_HASH,
          newDashboardConnectivityFilterHash: reqFilterHash,
        }
        dispatch(hashAction);
         try {
           setCustomerWiseChargerHealthGraphLoader(true);
           const response = await hwaxios.post(url, reqBody);

           if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardConnectivityFilterHash)) {
            const action: Partial<DashboardAction> = {
              type: dashboardTypes.FETCH_NEW_DASHBOARD_CONNECTIVITY_MEDIUM_DATA,
              newDashboardConnectivityMediumData: response.data?.data,
            };
            dispatch(action);
           }
           
           
           setCustomerWiseChargerHealthGraphLoader(true);
           return response.data;
         } catch (error) {
           console.error(error);
           setCustomerWiseChargerHealthGraphLoader(true);
           throw error;
         }
       };

export const fetchNewDashboardAlarmSeverityInfo :any = (reqBody) =>
  async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
    const url = baseUrl + '/newDashboard/alarm-severity-wise';
    try {
      const response = await hwaxios.post(url, reqBody);
      
      const action: Partial<DashboardAction> = {
        type: dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_SEVERITY_INFO,
        newDashboardAlarmSeverityInfo: response.data?.data,
      };
      dispatch(action);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

export const fetchNewDashboardActiveAlarmInfo :any = (reqBody) =>
  async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
    const url = baseUrl + '/newDashboard/alarm-active';
    try {
      const response = await hwaxios.post(url, reqBody);
      
      const action: Partial<DashboardAction> = {
        type: dashboardTypes.FETCH_NEW_DASHBOARD_ACTIVE_ALARM_INFO,
        newDashboardActiveAlarmsInfo: response.data?.data,
      };
      dispatch(action);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

export const fetchNewDashboardOutliersList :any = (reqBody) =>
  async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
    const url = baseUrl + '/newDashboard/alarm-outliers-list';
    try {
      const response = await hwaxios.post(url, reqBody);
      
      const action: Partial<DashboardAction> = {
        type: dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_OUTLIERS_LIST,
        newDashboardAlarmOutliersList: response.data?.data,
      };
      dispatch(action);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

export const fetchNewDashboardAlarmClearInfo :any = (reqBody) =>
  async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
    const url = baseUrl + '/newDashboard/alarm-clear-time';
    try {
      const response = await hwaxios.post(url, reqBody);

      const outliersList = response?.data?.data?.outliersList || [];

      const outlierAction: Partial<DashboardAction> = {
        type: dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_OUTLIERS_LIST,
        newDashboardAlarmOutliersList: outliersList,
      };
      dispatch(outlierAction);
      
      const action: Partial<DashboardAction> = {
        type: dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_CLEAR_TIME_INFO,
        newDashboardAlarmClearInfo: response.data?.data,
      };
      dispatch(action);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

export const fetchNewDashboardFailedTransactionList :any = (reqBody) =>
  async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
    const url = baseUrl + '/newDashboard/failed-transactions';
    // dispatch({
    //   type: dashboardTypes.FETCH_NEW_DASHBOARD_FAILED_TRANSACTION_LIST,
    //   newDashboardFailedTransactionList: null,
    // });

    const reqFilterHash = reqBody?.filters || {};
    const hashAction: Partial<DashboardAction> = {
      type: dashboardTypes.SET_NEW_DASHBOARD_FAILED_TRANSACTION_LIST_FILTER_HASH,
      newDashboardFailedTransactionListFilterHash: reqFilterHash,
    }
    dispatch(hashAction);
    
    try {
      const response = await hwaxios.post(url, reqBody);
      
      if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardFailedTransactionListFilterHash)) {
        const action: Partial<DashboardAction> = {
          type: dashboardTypes.FETCH_NEW_DASHBOARD_FAILED_TRANSACTION_LIST,
          newDashboardFailedTransactionList: response.data?.data,
        };
        dispatch(action);
      }
      
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  export const fetchNewDashboardChargingSessionsList :any = (reqBody) =>
    async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
      const url = baseUrl + '/newDashboard/charging-session-data';
      // dispatch({
      //   type: dashboardTypes.FETCH_NEW_CHARGING_SESSIONS_INFO,
      //   newDashboardChargingSessionsInfo: null,
      //   newDashboardChargingSessionsStats: null
      // });

      const reqFilterHash = reqBody?.filters || {};
      const hashAction: Partial<DashboardAction> = {
        type: dashboardTypes.SET_NEW_DASHBOARD_CHARGING_SESSION_FILTER_HASH,
        newDashboardChargingSessionFilterHash: reqFilterHash,
      }
      dispatch(hashAction);
      
      try {
        const response = await hwaxios.post(url, reqBody);
        
        if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardChargingSessionFilterHash)) {
          const action: Partial<DashboardAction> = {
            type: dashboardTypes.FETCH_NEW_CHARGING_SESSIONS_INFO,
            newDashboardChargingSessionsInfo: response.data?.data,
            newDashboardChargingSessionsStats: response.data?.stats
          };
          dispatch(action);
        }
        
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    export const fetchNewDashboardChargingSessionTrendList :any = (reqBody) =>
      async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
        const url = baseUrl + '/newDashboard/charging-session-time';
        // dispatch({
        //   type: dashboardTypes.FETCH_NEW_DASHBOARD_CHARGING_SESSION_TRENDS_INFO,
        //   newDashboardChargingSessionTrendInfo: null,
        // });

        const reqFilterHash = reqBody?.filters || {};
        const hashAction: Partial<DashboardAction> = {
          type: dashboardTypes.SET_CHARGING_SESSION_TREND_FILTER_HASH,
          newDashboardCharginsSessionTrendFilterHash: reqFilterHash,
        }
        dispatch(hashAction);
        try {
          const response = await hwaxios.post(url, reqBody);
          
          if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardCharginsSessionTrendFilterHash)) {
            const action: Partial<DashboardAction> = {
              type: dashboardTypes.FETCH_NEW_DASHBOARD_CHARGING_SESSION_TRENDS_INFO,
              newDashboardChargingSessionTrendInfo: response.data?.data,
            };
            dispatch(action);
          }
          return response.data;
        } catch (error) {
          console.error(error);
          throw error;
        }
      };

      export const fetchNewDashboardChargingVsIdleList :any = (reqBody) =>
        async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
          const url = baseUrl + '/newDashboard/idle-charging-time';
          // dispatch({
          //   type: dashboardTypes.FETCH_NEW_DASHBOARD_CHARGING_VS_IDLE_INFO,
          //   newDashboardChargingVsIdleInfo: null,
          // });

          const reqFilterHash = reqBody?.filters || {};
          const hashAction: Partial<DashboardAction> = {
            type: dashboardTypes.SET_DASHBOARD_CHARGING_VS_IDLE_FILTER_HASH,
            newDashboardChargingVsIdleFilterHash: reqFilterHash,
          }
          dispatch(hashAction);
          try {
            const response = await hwaxios.post(url, reqBody);

            if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardChargingVsIdleFilterHash)) {
              const action: Partial<DashboardAction> = {
                type: dashboardTypes.FETCH_NEW_DASHBOARD_CHARGING_VS_IDLE_INFO,
                newDashboardChargingVsIdleInfo: response.data?.data,
              };
              dispatch(action);
            }
            return response.data;
          } catch (error) {
            console.error(error);
            throw error;
          }
        };

        export const fetchNewDashboardEnergyTrendList :any = (reqBody) =>
          async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
            const url = baseUrl + '/newDashboard/energy-consumption-trend'; 
            // dispatch({
            //   type: dashboardTypes.FETCH_NEW_DASHBOARD_ENERGY_TREND_INFO,
            //   newDashboardEnergyTrendInfo: null,
            // });
            const reqFilterHash = reqBody?.filters || {};
            const hashAction: Partial<DashboardAction> = {
              type: dashboardTypes.SET_NEW_DASHDOARD_ENERGY_TREND_FILTER_HASH,
              newDashboardEnergyTrendFilterHash: reqFilterHash,
            }
            dispatch(hashAction);
            try {
              const response = await hwaxios.post(url, reqBody);
              
              if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardEnergyTrendFilterHash)) {
                const action: Partial<DashboardAction> = {
                  type: dashboardTypes.FETCH_NEW_DASHBOARD_ENERGY_TREND_INFO,
                  newDashboardEnergyTrendInfo: response.data?.data,
                };
                dispatch(action);
              }
              return response.data;
            } catch (error) {
              console.error(error);
              throw error;
            }
          };

          export const fetchNewDashboardOverallUptimeList :any = (reqBody) =>
            async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
              const url = baseUrl + '/newDashboard/chargers-uptime'; //todo

              const reqFilterHash = reqBody?.filters || {};
              const hashAction: Partial<DashboardAction> = {
                type: dashboardTypes.SET_NEW_DASHBOARD_UPTIME_FILTER_HASH,
                newDashboardUptimeFilterHash: reqFilterHash,
              }
              dispatch(hashAction);
              try {
                const response = await hwaxios.post(url, reqBody);
                
                if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardUptimeFilterHash)) {
                  const action: Partial<DashboardAction> = {
                    type: dashboardTypes.FETCH_NEW_DASHBOARD_OVERALL_UPTIME_INFO,
                    newDashboardOverallUptimeInfo: response.data?.data,
                  };
                  dispatch(action);
                }
                return response.data;
              } catch (error) {
                console.error(error);
                throw error;
              }
            };

            export const fetchNewDashboardAttentionRequiredList :any = (reqBody) =>
              async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
                const url = baseUrl + '/newDashboard/attention-required-chargers';

              dispatch({
              type: dashboardTypes.FETCH_NEW_DASHBOARD_ATTENTION_REQUIRED_DATA,
              newDashboardAttentionRequiredInfo: null,
            });

                const reqFilterHash = reqBody?.filters || {};
                const hashAction: Partial<DashboardAction> = {
                  type: dashboardTypes.SET_ATTENTION_REQUIRED_FILTER_HASH,
                  newDashboardAttentionRequiredFilterHash: reqFilterHash,
                }
                dispatch(hashAction);
                try {
                  const response = await hwaxios.post(url, reqBody);
                  
                  if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardAttentionRequiredFilterHash)) {
                    const action: Partial<DashboardAction> = {
                      type: dashboardTypes.FETCH_NEW_DASHBOARD_ATTENTION_REQUIRED_DATA,
                      newDashboardAttentionRequiredInfo: response.data?.data,
                    };
                    dispatch(action);
                  }
                  
                  return response.data;
                } catch (error) {
                  console.error(error);
                  throw error;
                }
              };

              export const fetchNewDashboardOldFormwareList :any = (reqBody) =>
                async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
                  const url = baseUrl + 'newDashboard/oldfirmware-list'; //todo
                  try {
                    const response = await hwaxios.post(url, reqBody);
                    return response.data;
                  } catch (error) {
                    console.error(error);
                    throw error;
                  }
                };

                export const fetchNewDashboardAlarmData :any = (reqBody) =>
                  async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
                    const url = baseUrl + '/newDashboard/alarmData'; //todo
                    try {
                      const response = await hwaxios.post(url, reqBody);
                      return response.data;
                    } catch (error) {
                      console.error(error);
                      throw error;
                    }
                  };

export const fetchNewDashboardFailedTransactionTopReasons :any = (reqBody) =>
  async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
    const url = baseUrl + '/newDashboard/failed-txn-reasons';
    // dispatch({
    //   type: dashboardTypes.FETCH_NEW_DASHBOARD_FAILED_TRANSACTION_TOP_REASONS,
    //   newDashboardFailedTransactionTopReasons: null,
    // });

    const reqFilterHash = reqBody?.filters || {};
    const hashAction: Partial<DashboardAction> = {
      type: dashboardTypes.SET_NEW_DASHBOARD_FAILED_TRANSACTION_TOP_REASONS_FILTER_HASH,
      newDashboardFailedTransactionTopReasonsFilterHash: reqFilterHash,
    }
    dispatch(hashAction);
    try {
      const response = await hwaxios.post(url, reqBody);
      
      if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardFailedTransactionTopReasonsFilterHash)) {
        const action: Partial<DashboardAction> = {
          type: dashboardTypes.FETCH_NEW_DASHBOARD_FAILED_TRANSACTION_TOP_REASONS,
          newDashboardFailedTransactionTopReasons: response.data?.data,
        };
        dispatch(action);
      }
      
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };


  export const fetchNewDashboardAIInsightsList :any = (reqBody) =>
    async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
      const url = baseUrl + '/insights';

      const reqFilterHash = reqBody?.filters || {};
      const hashAction: Partial<DashboardAction> = {
        type: dashboardTypes.SET_NEW_DASHBOARD_INSIGHTS_FILTER_HASH,
        newDashboardInsightsFilterHash: reqFilterHash,
      }
      dispatch(hashAction);
      try {
        setCustomerWiseChargerHealthGraphLoader(true);
        const response = await hwaxios.post(url, reqBody);
        
        if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardInsightsFilterHash)) {
          const action: Partial<DashboardAction> = {
            type: dashboardTypes.FETCH_NEW_DASHBOARD_AI_INSIGHTS_LIST,
            newDashboardAIInsights: response.data?.data || [],
          };
          dispatch(action);
        }
        setCustomerWiseChargerHealthGraphLoader(true);
        return response.data;
      } catch (error) {
        console.error(error);
        setCustomerWiseChargerHealthGraphLoader(true);
        throw error;
      }
    };

export const fetchNewDashboardAlarmSummaryList :any = (reqBody: any) =>
  async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
    const url = baseUrl + '/alarm/alarm-list';
    try {
      const loaderStartAction: Partial<DashboardAction> = {
        type: dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_SUMMARY_TABLE_LOADER,
        newDashboardAlarmSummaryTableLoader: true
      }
      dispatch(loaderStartAction);

      const reqFilterHash = reqBody?.filters || {};
      const hashAction: Partial<DashboardAction> = {
        type: dashboardTypes.SET_NEW_DASHBOARD_ALARM_SUMMARY_FILTER_HASH,
        newDashboardAlarmSummaryFilterHash: reqFilterHash,
      }
      dispatch(hashAction);

      const response = await hwaxios.post(url, reqBody);
      
      if(isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardAlarmSummaryFilterHash)) {
        const action: Partial<DashboardAction> = {
          type: dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_SUMMARY_LIST,
          newDashboardAlarmSummaryInfo: response.data?.data?.alarms,
        };
        dispatch(action);
      }
      
      const loaderEndAction: Partial<DashboardAction> = {
        type: dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_SUMMARY_TABLE_LOADER,
        newDashboardAlarmSummaryTableLoader: false
      }
      dispatch(loaderEndAction);
      
      return response.data;
    } catch (error) {
      console.error(error);

      const loaderEndAction: Partial<DashboardAction> = {
        type: dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_SUMMARY_TABLE_LOADER,
        newDashboardAlarmSummaryTableLoader: false
      }
      dispatch(loaderEndAction);
      throw error;
    }
  };



export const fetchNewDashboardEfficiencyTrendList: any = (reqBody) =>
  async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
    const url = baseUrl + '/newDashboard/charger-energy-efficiency';
    const reqFilterHash = reqBody?.filters || {};
    const hashAction: Partial<DashboardAction> = {
      type: dashboardTypes.SET_NEW_DASHDOARD_EFFICIENCY_TREND_FILTER_HASH,
      newDashboardEfficiencyTrendFilterHash: reqFilterHash,
    }
    dispatch(hashAction);
    try {
      const response = await hwaxios.post(url, reqBody);

      if (isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardEfficiencyTrendFilterHash)) {
        const action: Partial<DashboardAction> = {
          type: dashboardTypes.FETCH_NEW_DASHBOARD_EFFICIENCY_TREND_INFO,
          newDashboardEfficiencyTrendInfo: response.data?.data?.timeBlocks,
          newDashboardCustomerAverageEfficiency: response.data?.data?.customerAverageEfficiency
        };

        dispatch(action);
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
export const fetchNewDashboardReactiveEnergyConsumptionTrendList: any = (reqBody) =>
  async (dispatch: (arg0: Partial<DashboardAction>) => void): Promise<void> => {
    const url = baseUrl + '/newDashboard/charger-reactive-energy';
    const reqFilterHash = reqBody?.filters || {};
    const hashAction: Partial<DashboardAction> = {
      type: dashboardTypes.SET_NEW_DASHDOARD_REACTIVE_ENERGY_CONSUMPTION_TREND_FILTER_HASH,
      newDashboardReactiveEnergyConsumptionTrendFilterHash: reqFilterHash,
    }
    dispatch(hashAction);
    try {
      const response = await hwaxios.post(url, reqBody);

      if (isEqual(reqFilterHash, rmsStore.getState().dashboardReducer.newDashboardReactiveEnergyConsumptionTrendFilterHash)) {
        const action: Partial<DashboardAction> = {
          type: dashboardTypes.FETCH_NEW_DASHBOARD_REACTIVE_ENERGY_CONSUMPTION_TREND_INFO,
          newDashboardReactiveEnergyConsumptionTrendInfo: response.data?.data?.timeBlocks,
          newDashboardCustomerAverageReactiveEnergyConsumption: response.data?.data?.customerReactiveEnergyAverage
        };
        dispatch(action);
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  };